function formatFilename(filename) {
    if (filename.length >= 16) {
        return filename.substring(0, 16) + "...";
    } else {
        return filename;
    }
}

export default formatFilename;
